import * as types from './types';
import { loading } from 'State/actions';
import { createToast, toastType } from 'Common/ToastHelper';

export const getInitialData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SERVED_ITEM_SETUP_FETCHING, true));

    try {
      const servedItemsResponse = await MPWWebApi.getGeneric('serveditem/all');
      dispatch({
        type: types.SERVED_ITEM_SETUP_GET_DATA,
        payload: {
          servedItems: servedItemsResponse.data.Data,
        },
      });
    } catch (error) {
      dispatch({
        type: types.SERVED_ITEM_SETUP_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.SERVED_ITEM_SETUP_FETCHING, false));
  };
};

export const deleteItem = itemId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SERVED_ITEM_SETUP_FETCHING, true));

    try {
      await MPWWebApi.getGeneric(`ServedItem/delete/${itemId}`);
      createToast(toastType.success, 'Success', 'Item successfully deleted.');
      dispatch(getInitialData());
    } catch (error) {
      createToast(toastType.error, 'Error', error.response.data.Data);
      dispatch({
        type: types.SERVED_ITEM_SETUP_FETCH_ERROR,
        payload: error.response.data.Data,
      });
      dispatch(loading(types.SERVED_ITEM_SETUP_FETCHING, false));
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/state/serveditemsetup/actions.js